import { APP_NAME } from '../config/brand'

export function AuthLayout({ children }) {
  return (
    <div className="relative flex min-h-dvh flex-col overflow-hidden bg-background text-foreground">
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 h-96 w-96 rounded-full bg-primary/20 blur-3xl float-animation" />
        <div className="absolute top-1/2 -left-40 h-80 w-80 rounded-full bg-accent/15 blur-3xl float-animation-delayed" />
        <div className="absolute -bottom-40 right-1/3 h-72 w-72 rounded-full bg-primary/10 blur-3xl float-animation-slow" />
      </div>
      <div className="relative z-10 flex flex-1 flex-col items-center justify-center px-4 py-12">
        {children}
      </div>
      <p className="relative z-10 pb-6 text-center text-xs text-muted-foreground">
        {APP_NAME} · For platform team members only
      </p>
    </div>
  )
}
